import React, { useState, useEffect } from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { wsGetAll } from 'services/WService';
import Modal from 'components/Tvendo/Common/ModalBase';
import styles from 'assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js';
import { makeStyles } from '@material-ui/core/styles';
import SweetAlert from 'react-bootstrap-sweetalert';
import { onlyInteger } from 'hooks/Pipe';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';

const useStyles = makeStyles(styles);

export default function ModalDistributionStaff(props) {
  const classes = useStyles();

  const dStaff = props.model;
  const [dataChanging, setDataChanging] = useState(dStaff);
  const [employeeStatus, setEmployeeStatus] = useState([]);
  const [employeePositions, setEmployeePositions] = useState([]);

  const [alert, setAlert] = useState(null);
  function messageResponse(response) {
    if (!response.data.password) {
      return setAlert(null);
    }
    setAlert(
      <SweetAlert
        style={{ display: 'block', marginTop: '-100px' }}
        title={`Usuario: ${response.data?.user.email} // Clave: ${response.data?.password}`}
        onConfirm={() => {
          setAlert(null);
          props.reload();
        }}
        onCancel={() => setAlert(null)}
        confirmBtnCssClass={classes.button + ' ' + classes.success}
      />,
    );
  }

  const [zones, setZones] = useState([]);
  async function listEmployeeStatus() {
    let response = await wsGetAll('base/employee-status');
    if (response.success) setEmployeeStatus(response.data);
  }

  async function listEmployeePosition() {
    let response = await wsGetAll('base/employee-positon');
    if (response.success) setEmployeePositions(response.data);
  }

  async function listZones() {
    let response = await wsGetAll('base/zone');
    if (response.success) setZones(response.data);
  }

  function handleChange(field, value) {
    setDataChanging({ ...dataChanging, [field]: value });
  }

  useEffect(() => {
    if (dStaff.open) {
      listEmployeeStatus();
      listEmployeePosition();
      listZones();
    }
  }, [dStaff.open]);

  return (
    <>
      {alert}
      <Modal
        title="Personal de distribución"
        model={dStaff}
        setOpen={props.setOpen}
        showNotify={props.showNotify}
        reload={props.reload}
        dataChanging={dataChanging}
        setDataChanging={setDataChanging}
        entity="prog/distribution-staff"
        responseData={messageResponse}
        maxWidth={'md'}
        state
      >
        <GridContainer>
          {/* Codigo (Dni) */}
          <GridItem xs={12} sm={6}>
            <TextField
              label="Código (Dni)"
              fullWidth
              name="code"
              margin="normal"
              defaultValue={!!dStaff ? dStaff.code : ''}
              required
            />
          </GridItem>
          {/* Celular */}
          <GridItem xs={12} sm={6}>
            <TextField
              label="Celular"
              fullWidth
              name="phone"
              margin="normal"
              defaultValue={!!dStaff ? dStaff.phone : ''}
              onKeyPress={onlyInteger}
              inputProps={{ minLength: 9, maxLength: 9 }}
              required
            />
          </GridItem>

          {/* Nombre completo */}
          <GridItem xs={12}>
            <TextField
              label="Nombre completo"
              fullWidth
              name="name"
              margin="normal"
              defaultValue={!!dStaff ? dStaff.name : ''}
              required
            />
          </GridItem>
          {/* FirstName */}
          <GridItem xs={12} sm={6}>
            <TextField
              label="Nombres"
              fullWidth
              name="FirstName"
              margin="normal"
              defaultValue={!!dStaff ? dStaff.FirstName : ''}
              required
            />
          </GridItem>
          {/* LastName */}
          <GridItem xs={12} sm={6}>
            <TextField
              label="Apellidos"
              fullWidth
              name="LastName"
              margin="normal"
              defaultValue={!!dStaff ? dStaff.LastName : ''}
              required
            />
          </GridItem>

          <GridItem xs={12}>
            <TextField
              label="Licencia de conducir"
              fullWidth
              name="driver_license"
              margin="normal"
              defaultValue={!!dStaff ? dStaff.driver_license : ''}
              required
            />
          </GridItem>

          {employeeStatus.length > 0 ? (
            <GridItem xs={12} sm={6}>
              <Autocomplete
                disableClearable
                options={employeeStatus}
                getOptionLabel={(option) => option.description}
                defaultValue={
                  !!dStaff
                    ? employeeStatus.find((item) => item.id == dStaff.base_employee_status_id)
                    : undefined
                }
                renderInput={(params) => (
                  <TextField {...params} label="Estado empleado" margin="normal" required />
                )}
                onChange={(e, item) => {
                  handleChange('base_employee_status_id', item.id);
                }}
              />
            </GridItem>
          ) : undefined}

          {employeePositions.length > 0 ? (
            <GridItem xs={12} sm={6}>
              <Autocomplete
                disableClearable
                options={employeePositions}
                getOptionLabel={(option) => option.description}
                defaultValue={
                  !!dStaff
                    ? employeePositions.find((item) => item.id == dStaff.base_employee_positon_id)
                    : undefined
                }
                renderInput={(params) => (
                  <TextField {...params} label="Posición de empleado" margin="normal" required />
                )}
                onChange={(e, item) => {
                  if (!!item) {
                    return handleChange('base_employee_positon_id', item.id);
                  }
                  handleChange('base_employee_positon_id', null);
                }}
              />
            </GridItem>
          ) : undefined}
        </GridContainer>

        {zones.length > 0 ? (
          <Autocomplete
            disableClearable
            options={zones}
            getOptionLabel={(option) => option.description}
            defaultValue={
              !!dStaff ? zones.find((zone) => zone.id == dStaff.base_zone_id) : undefined
            }
            renderInput={(params) => (
              <TextField {...params} label="Zona" margin="normal" required />
            )}
            onChange={(e, item) => {
              handleChange('base_zone_id', item.id);
            }}
          />
        ) : undefined}

        {dataChanging.base_employee_positon_id == 2 || dStaff.base_employee_positon_id == 2 ? (
          <FormControl fullWidth margin="normal" size="small">
            <InputLabel>Liquidación múltiple</InputLabel>
            <Select
              defaultValue={dStaff.massive_liquidation || 'N'}
              inputProps={{ name: 'massive_liquidation' }}
            >
              <MenuItem value="Y">Si</MenuItem>
              <MenuItem value="N">No</MenuItem>
            </Select>
          </FormControl>
        ) : undefined}
          <FormControl fullWidth margin="normal" size="small">
            <InputLabel>Tipo de comisión</InputLabel>
            <Select
              defaultValue={dStaff.tipo_comision || '1'}
              inputProps={{ name: 'tipo_comision' }}
            >
              <MenuItem value="1">Tipo comisión 1</MenuItem>
              <MenuItem value="2">Tipo comisión 2</MenuItem>
            </Select>
          </FormControl>
      </Modal>
    </>
  );
}
